import Modal from "./Modal";
import styles from "./AddHouseNumberModal.module.css";

export default function AddHouseNumberModal({ onClose, onSubmit }) {
    return (
        <Modal onClose={onClose}>
            <div className={styles.container}>
                <div className={styles.text}>
                    <strong> Niste upisali kućni broj! </strong> Kako bi smo
                    mogli preciznije provjeriti uslugu na vašoj adresi potrebna
                    nam je potpuna adresa.
                    <br />
                    <br />
                    Upišite kućni broj nakon naziva ulice. Ako nemate kućni broj
                    u tražilicu dodajte <strong>"bb"</strong> nakon naziva
                    ulice.
                </div>
                <div className={styles.actions}>
                    <div
                        className={`${styles.button} ${styles.submit}`}
                        onClick={onSubmit}
                    >
                        Nastavite bez kućnog broja
                    </div>
                    <div
                        className={`${styles.button} ${styles.close}`}
                        onClick={onClose}
                    >
                        Upišite kućni broj
                    </div>
                </div>
            </div>
        </Modal>
    );
}
